import React from 'react';

import { MESSAGING_SERVICE_FIELDS } from '../../common/fields';
import TextInput from '../Controls/TextInput/TextInput';
import SelectInput from '../Controls/SelectField/SelectField';
import Certificate from '../Controls/Certificate/Certificate';
import SwitchField from '../Controls/SwitchField/SwitchField';

import styles from './MessagingService.module.css';

import { CSR_TYPES } from '../../common/certTypes';
import { SERVER_TYPE } from '@silverfort-nodelibs/common/utils/consts';
const { NAME, SERVER_URL, DMZ, CERTIFICATE, CERTIFICATE_REQUEST, CUSTOM_CERTIFICATE, ID_FIELD } =
    MESSAGING_SERVICE_FIELDS;

const MessagingService = ({ messagingService, changedFunc }) => {
    return (
        <div className={styles.messagingService}>
            <TextInput field={messagingService[NAME.ID]} color="grey" changed={changedFunc} />
            <TextInput
                field={messagingService[SERVER_URL.ID]}
                placeholder="127.0.0.1"
                color="grey"
                changed={changedFunc}
            />
            <SelectInput
                field={messagingService[DMZ.ID]}
                color="grey"
                changed={changedFunc}
                options={[
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' }
                ]}
            />
            <div></div>
            <div>
                <SwitchField field={messagingService[CUSTOM_CERTIFICATE.ID]} changed={changedFunc} />
                {messagingService[CUSTOM_CERTIFICATE.ID].value && (
                    <Certificate
                        id={messagingService[ID_FIELD.ID].value}
                        baseName={messagingService[NAME.ID].value}
                        header={CERTIFICATE.NAME}
                        desc="Upload a custom certificate to set up trusted communication between the Desktop App and the Desktop Messaging Service"
                        certificate={messagingService[CERTIFICATE.ID]}
                        certificateRequest={messagingService[CERTIFICATE_REQUEST.ID]}
                        certType={CSR_TYPES.PUSH_SERVICES}
                        serverType={SERVER_TYPE.ARYA}
                        changed={changedFunc}
                    />
                )}
            </div>
        </div>
    );
};

export default React.memo(MessagingService);
